const actionTypes = { SET_GALLERY_PROFILE_CONTENT: 'SET_GALLERY_PROFILE_CONTENT' };

module.exports = actionTypes;
